// extracted by mini-css-extract-plugin
export default {"row":"GhIawBIuhWVg0GXTvRMV","collapseRow":"oTKvKtyazV1cIR4GdTdW","collapseContent":"t6mrfw5d3cpQWI221BDA"};